module.exports = __webpack_public_path__ + "4e4b54eff7ce6f0925989b8e322ce55e.pdf";